module.exports = function() {
  return new Worker(__webpack_public_path__ + "cb0c7c0516a51bc7199e.worker.js");
};